// Field configurations for Admin dialog forms
export const PKG_FIELDS = [
  { key: "slug", label: "Slug" },
  { key: "name_id", label: "Nama (ID)" },
  { key: "name_en", label: "Name (EN)" },
  { key: "category", label: "Kategori (umrah / haji)" },
  { key: "duration", label: "Durasi" },
  { key: "price_idr", label: "Harga IDR (number)", type: "number" },
  { key: "price_label_id", label: "Label Harga (ID)" },
  { key: "price_label_en", label: "Label Harga (EN)" },
  { key: "description_id", label: "Deskripsi (ID)", type: "richtext" },
  { key: "description_en", label: "Description (EN)", type: "richtext" },
  { key: "highlights_id", label: "Highlights (ID, 1 per baris)", type: "array" },
  { key: "highlights_en", label: "Highlights (EN, 1 per baris)", type: "array" },
  { key: "inclusions_id", label: "Inclusions (ID, 1 per baris)", type: "array" },
  { key: "inclusions_en", label: "Inclusions (EN, 1 per baris)", type: "array" },
  { key: "itinerary", label: "Itinerary Hari-per-Hari", type: "itinerary" },
  { key: "image", label: "URL Gambar" },
  { key: "departure", label: "Keberangkatan (label)" },
  { key: "departure_date", label: "Tanggal Keberangkatan (YYYY-MM-DD)" },
  { key: "featured", label: "Featured?", type: "boolean" },
];

export const TST_FIELDS = [
  { key: "name", label: "Nama" },
  { key: "location", label: "Lokasi" },
  { key: "package", label: "Paket" },
  { key: "rating", label: "Rating (1-5)", type: "number" },
  { key: "text_id", label: "Testimoni (ID)", type: "textarea" },
  { key: "text_en", label: "Testimony (EN)", type: "textarea" },
  { key: "avatar", label: "URL Foto" },
];

export const BLOG_FIELDS = [
  { key: "slug", label: "Slug" },
  { key: "title_id", label: "Judul (ID)" },
  { key: "title_en", label: "Title (EN)" },
  { key: "excerpt_id", label: "Excerpt (ID)", type: "textarea" },
  { key: "excerpt_en", label: "Excerpt (EN)", type: "textarea" },
  { key: "content_id", label: "Konten (ID)", type: "textarea", rows: 8 },
  { key: "content_en", label: "Content (EN)", type: "textarea", rows: 8 },
  { key: "cover", label: "URL Cover" },
  { key: "author", label: "Penulis" },
  { key: "category", label: "Kategori" },
  { key: "published_at", label: "Tanggal (YYYY-MM-DD)" },
];

export const GAL_FIELDS = [
  { key: "title_id", label: "Judul (ID)" },
  { key: "title_en", label: "Title (EN)" },
  { key: "image", label: "URL Gambar" },
  { key: "span", label: "Grid span (e.g. md:col-span-2 md:row-span-1)" },
];

export const STATUS_OPTIONS = [
  { v: "new", label: "Baru", color: "bg-blue-100 text-blue-800" },
  { v: "contacted", label: "Dihubungi", color: "bg-amber-100 text-amber-800" },
  { v: "confirmed", label: "Konfirmasi", color: "bg-emerald-100 text-emerald-800" },
  { v: "cancelled", label: "Batal", color: "bg-red-100 text-red-800" },
];
